module.exports = __webpack_public_path__ + "img/user1.f60dacf0.svg";